<template>
  <div>
    <canvas ref="canvas"
            :width="width"
            :height="height"
            :style="canvasStyle"></canvas>
  </div>
</template>

<script>
  import Animator from './Animator'
  import Circles from './animation/Circles'

  export default {
    props: {
      playing: {
        type: Boolean,
        default: true
      },
      width: {
        type: Number,
        default: 80
      },
      height: {
        type: Number,
        default: 80
      },
      canvasStyle: {
        type: Object
      },
      type: {
        type: String,
        default: 'circles'
      }
    },
    data () {
      return {
        animator: null
      }
    },
    mounted () {
      const canvas = this.$refs.canvas
      const context = canvas.getContext('2d')
      if (!this.animator) {
        let animation = null
        switch (this.type) {
          case 'circles':
          default:
            animation = new Circles(context, this.width / 2, this.height / 2)
            break
        }
        this.animator = new Animator(animation)
      }
      if (this.playing) {
        this.animator.play()
      }
    },
    watch: {
      'playing': function (val, oldVal) {
        if (this.animator) {
          if (val && !oldVal) {
            this.animator.play()
          } else if (!val && oldVal) {
            this.animator.pause()
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?7fb68924